module.exports = __webpack_public_path__ + "img/06-9.bfcfecb5.png";